module.exports = __webpack_public_path__ + "static/ysu-web-2-d59ecd595d4ee09009a7742ded888c60.jpg";